import { TooltipProvider } from '@visx/xychart';

/**
 * Provides cursor/tooltip context for accessing cursor data outside of the chart.
 *
 * Only needed when you want to use the useCursor hook to access cursor state from
 * components outside the chart (e.g., displaying the hovered value in a separate element).
 * The Cursor component itself works without this provider.
 *
 * @example
 * ```tsx
 * function ExternalValue() {
 *   const { data } = useCursor();
 *   return <div>Current value: {data?.value}</div>;
 * }
 *
 * function MyChart() {
 *   return (
 *     <CursorProvider>
 *       <ExternalValue />
 *       <XYChart width={500} height={300}>
 *         <AreaSeries data={data} dataKey="series1" xAccessor={d => d.x} yAccessor={d => d.y} />
 *         <Cursor formatDataPointLabel={(d) => `${d.value}`} />
 *       </XYChart>
 *     </CursorProvider>
 *   );
 * }
 * ```
 */
export const CursorProvider = ({ children }: { children: React.ReactNode }) => {
  return <TooltipProvider>{children}</TooltipProvider>;
};
